angular.module('LeasePilot').directive('deleteUserConfirmationModal', [
  '$rootScope',
  '$mdDialog',
  '$http',
  'UsersService',
  function(
    $rootScope,
    $mdDialog,
    $http,
    UsersService,
  ) {
    return {
      restrict: 'E',
      templateUrl: 'delete_user_confirmation_modal.html',
      scope: {
        id: "@",
        email: "@",
      },
      link: function($scope) {
        // 
        $scope.delete = function() {
          const user = window.users.find(u => u.id === parseInt($scope.id));

          new UsersService({ id: $scope.id }).delete().then(
            function() {
              if (user) {
                window.track.event(new DeleteUserEvent({
                  id: $scope.id,
                  email: user.email,
                  firstName: user.firstName,
                  lastName: user.lastName,
                }));
              }
              $mdDialog.cancel();
              window.location.reload();
            },
            function(error) {
              $scope.error = error.data.error;
              throw error;
            },
          );
        };

        $scope.cancel = function() {
          window.track.event(new CancelDeleteUserEvent({
            id: $scope.id,
          }));
          $mdDialog.cancel();
        };
      },
    };
  },
]);
